import clsx from 'clsx';
import { usePDPData } from '~/features/product-details/context';
import { Typography } from '~/shared/components';
import { useProductLabels } from '~/shared/hooks/useProductLabels';
import styles from './ProductTags.module.scss';
import { normalizeHexColor } from '~/shared/utils/colors';

interface Props {
    itemClassName?: string;
}

export const ProductTags: React.FC<Props> = ({ itemClassName }) => {
    const { product } = usePDPData();
    const tags = useProductLabels(product);

    if (!tags?.length) return null;

    return (
        <>
            {tags.map((tag) => (
                <Typography
                    key={tag.displayText}
                    className={clsx(styles.productTag, itemClassName)}
                    variant="paragraph-S"
                    as="div"
                    style={{
                        backgroundColor: normalizeHexColor(tag.backgroundColor),
                        color: normalizeHexColor(tag.textColor),
                    }}
                >
                    <span>{tag.displayText}</span>
                </Typography>
            ))}
        </>
    );
};
